import React from "react";

interface LinkButtonProps {
  href: string;
  children: any;
  className?: string;
  target?:string;
  title?:string;
}

const LinkButton: React.FC<LinkButtonProps> = ({
  href,
  children,
  className,
  target,
  title
}) => {
  return (
    <a
      href={href}
      className={className}
      target={target}
      rel="noopener noreferrer"
    >
      {children}{title}
    </a>
  );
};

export default LinkButton;
